import {
  STORE_ERA_LIST,
  RESET_ERA_LIST,
  STORE_ERA_CURRENT,
  SET_ERA_MODAL,
  STORE_ERA_PDF,
  CLEAR_ERA,
} from "../actions/actionTypes";

const initialState = {
  eraList: [],
  currentEraData: {},
  openEraModal: false,
  eraPdf: null,
  addERATabs: {},
};

const eraReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case STORE_ERA_LIST:
      return {
        ...state,
        eraList: action.payload,
      };
    case "ADD_ERA_TAB":
      return {
        ...state,
        addERATabs: {
          ...state.addERATabs,
          ...action.addData,
        },
      };
    case "REMOVE_ERA_TAB":
      return {
        ...state,
        addERATabs: {
          ...state.addERATabs,
          [action.id]: undefined,
        },
      };
    case RESET_ERA_LIST:
      return {
        ...state,
        eraList: [],
      };
    case STORE_ERA_CURRENT:
      return {
        ...state,
        currentEraData: action.payload,
      };
    case SET_ERA_MODAL:
      return {
        ...state,
        openEraModal: action.payload,
      };
    case STORE_ERA_PDF:
      return {
        ...state,
        eraPdf: action.payload,
      };
    case CLEAR_ERA:
      return { ...initialState };
    default:
      return state;
  }
};

export default eraReducer;
